import Settings from '../../resources/settings';
import commonStrings from '../../resources/commonStrings';
import { getAvailableReports } from '../utils';

export const reportDetails = [
  {
    identifier: 'studentsWithoutValidTestResults',
    grouping: commonStrings.reportGroupingTitle.testingProgressReports,
    title: commonStrings.reportTitle.studentsWithoutValidTestResults,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/studentsWithoutValidTestResultsOrgSelection.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.studentsWithoutValidTestResults,
    },
    isEnabled: true,
  },
  {
    identifier: 'testEventsByStatus',
    grouping: commonStrings.reportGroupingTitle.testingProgressReports,
    title: commonStrings.reportTitle.testEventsByStatus,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/testEventsByStatusOrgSelection.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.testEventsByStatus,
    },
    isEnabled: true,
  },

  {
    identifier: 'studentsWithoutReportingAttributes',
    grouping: commonStrings.reportGroupingTitle.reportingIssuesReports,
    title: commonStrings.reportTitle.studentsWithoutReportingAttributes,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/studentsWithoutReportingAttributes.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.studentsWithoutReportingAttributes,
    },
    isEnabled: true,
  },
  {
    identifier: 'instructorsWithoutClassAssignments',
    grouping: commonStrings.reportGroupingTitle.reportingIssuesReports,
    title: commonStrings.reportTitle.instructorsWithoutClassAssignments,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/teachersWithoutClassAssignments.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.instructorsWithoutClassAssignments,
    },
    isEnabled: true,
  },
  {
    identifier: 'studentsByDistrict',
    grouping: commonStrings.reportGroupingTitle.reportingIssuesReports,
    title: commonStrings.reportTitle.studentsByDistrict,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/studentsByDistrict.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.studentsByDistrict,
    },
    isEnabled: true,
  },

  {
    identifier: 'profilesWithSharedIDs',
    grouping: commonStrings.reportGroupingTitle.userProfileReports,
    title: commonStrings.reportTitle.profilesWithSharedIDs,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/sharedId.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.profilesWithSharedIDs,
    },
    isEnabled: true,
  },
  {
    identifier: 'userRoles',
    grouping: commonStrings.reportGroupingTitle.userProfileReports,
    title: commonStrings.reportTitle.userRoles,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/userRoles.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.userRoles,
    },
    isEnabled: true,
  },
  {
    identifier: 'potentialDuplicateProfiles',
    grouping: commonStrings.reportGroupingTitle.userProfileReports,
    title: commonStrings.reportTitle.potentialDuplicateProfiles,
    linkTarget: `${Settings.ADMIN_BASE_PATH}/report/operational/potentialDuplicateProfiles.seam`,
    details: {
      listItems: commonStrings.reportDetailsList.potentialDuplicateProfiles,
    },
    isEnabled: true,
  },
];

export const reportIdentifiers = getAvailableReports(reportDetails);

export default reportDetails;
